import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import { between } from "../style/style";
import { alpha, IconButton, useMediaQuery, useTheme, } from "@mui/material";
import { BackIcon } from "@ui/assets/custom-icons/back-icon";
import { Link as RouterLink } from "react-router-dom";
/**
 * Generic page header component with title, optional subtitle, and right-aligned actions.
 */
export const PageHeader = ({ title, subtitle, breadcrumbs: breadcrumbItems, actions, startActions, actions2, children, onBack, }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));
    return (React.createElement(Box, { sx: Object.assign(Object.assign({}, between), { background: (t) => t.palette.background.default, flex: 1, pb: 1 }), gap: 1 },
        (title || subtitle) && (React.createElement(Box, { display: "flex", alignItems: "center", gap: isMobile ? 1 : 2, flex: 1, minWidth: 0 },
            onBack && (React.createElement(IconButton, { size: "large", style: {
                    color: theme.palette.tertiary.main,
                    border: `1px solid ${alpha(theme.palette.primary.main, 0.4)}`,
                }, onClick: onBack },
                React.createElement(BackIcon, null))),
            React.createElement(Box, { display: "flex", flexDirection: "column", flex: 1, minWidth: 0 },
                React.createElement(Box, { display: "flex", width: "100%", flexDirection: isMobile ? "column" : "row", alignItems: isMobile ? undefined : "baseline", gap: isMobile ? 0 : 1 },
                    React.createElement(Typography, { variant: "h3", fontFamily: "PowerGrotesk", fontWeight: 400, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", flexShrink: 0 }, title),
                    subtitle && (React.createElement(Typography, { variant: "caption", color: "text.tertiary", flex: 1, minWidth: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" },
                        "(",
                        subtitle,
                        ")"))),
                breadcrumbItems && breadcrumbItems.length > 0 && (React.createElement(Breadcrumbs, { "aria-label": "breadcrumb", separator: "\u2192", sx: {
                        mt: 0.5,
                        "& .MuiBreadcrumbs-separator": {
                            mx: 1,
                            color: "text.secondary",
                        },
                        "& .MuiBreadcrumbs-li": {
                            "& > *": {
                                fontSize: "0.75rem",
                                fontWeight: 400,
                                color: "text.secondary",
                            },
                        },
                        "& .MuiBreadcrumbs-li:last-of-type > *": {
                            color: "text.primary",
                        },
                    } }, breadcrumbItems.map((item, index) => {
                    const isLast = index === breadcrumbItems.length - 1;
                    if (item.path && !isLast) {
                        return (React.createElement(Link, { key: index, component: RouterLink, to: item.path, underline: "hover", color: "inherit", sx: {
                                "&:hover": { color: "primary.main" },
                            } }, item.label));
                    }
                    return (React.createElement(Typography, { key: index, component: "span", variant: "body2" }, item.label));
                }))),
                children))),
        startActions && (React.createElement(Box, { display: "flex", alignItems: "center", justifyContent: "flex-start", gap: 1.5 }, startActions)),
        actions && (React.createElement(Box, { display: "flex", alignItems: "center", justifyContent: "flex-end", gap: 1.5 }, actions)),
        actions2 && (React.createElement(Box, { display: "flex", alignItems: "center", gap: 1 }, actions2))));
};
